export const WALLET_LOADING = "WALLET_LOADING";
export const WALLET_ERROR = "WALLET_ERROR";
export const WALLET_GET_LIST = "WALLET_GET_LIST";
export const WALLET_GET_FILTERS = "WALLET_GET_FILTERS";
export const WALLET_GET_SINGLE = "WALLET_GET_SINGLE";



// WEBPACK FOOTER //
// ./src/actions/wallet/constants.js